import { CallAPI } from "../../apiManager/ApiCall";
import { affiliationEarnersURL } from "apiManager/APIConfig";

/** Admin: list all withdrawal requests — GET /api/affiliation/all-withdrawal */
export const GetAllWithdrawalsCall = async () => {
  try {
    const response = await CallAPI({
      url: "affiliation/all-withdrawal",
      method: "GET",
    });
    if (response?.success && Array.isArray(response?.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

/** Admin: list users with active earning tab + sales summary — GET /api/affiliation/earners */
export const GetEarnersCall = async () => {
  try {
    const response = await CallAPI({
      url: affiliationEarnersURL,
      method: "GET",
    });
    if (response?.success && Array.isArray(response?.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};

/** Admin: get sales progress (conversions) for one earner — GET /api/affiliation/earners/:userId/sales */
export const GetEarnerSalesCall = async (userId) => {
  try {
    const response = await CallAPI({
      url: `${affiliationEarnersURL}/${userId}/sales`,
      method: "GET",
    });
    if (response?.success && response?.data) {
      return response.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

/** Admin: mark withdrawal as paid (payoff) — POST /api/affiliation/withdrawal-status */
export const UpdateWithdrawalStatusCall = async (withdrawalId, status) => {
  try {
    const response = await CallAPI({
      url: "affiliation/withdrawal-status",
      method: "POST",
      body: { id: withdrawalId, status },
    });
    return response?.success ? response : null;
  } catch (error) {
    return null;
  }
};

/** Admin: undo payoff — POST /api/affiliation/withdrawal/:withdrawalId/undo */
export const UndoWithdrawalPayoffCall = async (withdrawalId) => {
  try {
    const response = await CallAPI({
      url: `affiliation/withdrawal/${withdrawalId}/undo`,
      method: "POST",
    });
    return response?.success ? response : null;
  } catch (error) {
    return null;
  }
};
